// extracted by mini-css-extract-plugin
export default {"questionWrapper":"Question_questionWrapper__8AfMc","topRow":"Question_topRow__u-pWl","responseParagraph":"Question_responseParagraph__ihbfU"};